{
  "widget": {
    "intakeIntro": "Customize the intake form and widget appearance for your venue's chat widget",
    "customizeFields": "Customize Fields",
    "customizeEventTypes": "Customize event types",
    "customizeTime": "Customize time",
    "customizeHoursBody": "Customize the hours for which users can inquire about.",
    "appearanceIntro": "Customize how your chat widget looks to guests.",
    "inquiryFormHelp": "Shown to guests while they fill out inquiry form. Edit to set expectations, share any special instructions, or add a personal welcome.",
    "enableInquiryHoursOverride": "Enable inquiry hours override",
    "selectDayInquiryHours": "Select a day above to add inquiry hours for that day.",
    "colors": {
      "heading": "Widget Colors",
      "intro": "Apply your brand colors to the widget. Learn more about <0>web accessibility</0>.",
      "formBackground": "Background Color",
      "text": "Text Color",
      "accent": "Accent Color",
      "formButtons": "Button Color",
      "accentNoun": "the accent color",
      "buttonNoun": "the button color",
      "hexAria": "{{label}} hex color",
      "pickerAria": "{{label}} color picker"
    },
    "a11y": {
      "intro": "Web Content Accessibility Guidelines (WCAG) 2 is developed through the <0>W3C process</0> in cooperation with individuals and organizations around the world, with a goal of providing a single shared standard for web content accessibility.",
      "colorContrast": "Color Contrast",
      "checker": "Our color contrast checker aligns with the WCAG 2.2 guidelines and ratios."
    },
    "gtmHelpCenter": "See our help center for instructions (opens in a new tab)"
  },
  "survey": {
    "customizeWidget": "Customize My Widget",
    "canceling": "Canceling...",
    "prioritizeQuestions": "Your agent will prioritize these questions during the conversation. Customize them so the agent collects the most relevant information for your venue."
  },
  "reservations": {
    "status": {
      "canceled": "Canceled"
    },
    "holdCanceled": {
      "title": "Hold Canceled",
      "body": "The reservation hold has been canceled successfully."
    },
    "organizer": "Organizer",
    "cancelingHold": "Canceling Hold...",
    "venueRequest": {
      "finalizingMenu": "Finalizing menu selections or guest count"
    },
    "tasks": {
      "finalizeMenu": "Finalize Menu"
    },
    "expenses": {
      "fetchError": "Something went wrong when fetching the check",
      "fetchErrorBody": "Refresh this page or try again later.",
      "uploadCheck": "Upload Check",
      "itemizedCheck": "Itemized Check",
      "noCheckDetected": "No Check Detected",
      "checkDetailsPending": "Your check details will be here after the reservation.",
      "editItemizedCheckTitle": "Edit Itemized Check",
      "uploadItemizedCheckTitle": "Upload Itemized Check",
      "uploadCheckPostTitle": "Upload the itemized check which shows all the items that were purchased, tax, and any mandatory gratuity",
      "editCheckButton": "Edit Check",
      "deleteItemizedCheckLabel": "Delete Itemized Check",
      "checkDetailsLabel": "Check Details",
      "itemizedCheckFileLabel": "Itemized Check File",
      "deleteCheckConfirmButton": "Yes, Delete Check",
      "keepCheckButton": "Keep Check",
      "uploadedCheckAlt": "uploaded check"
    }
  },
  "accounts": {
    "inviteBody": "Dear {{inviteeFirstName}},\n\nI'm reaching out because we're rolling out a new program designed specifically for our most valued partners. The program will make discovering, booking, and paying for reservations at {{venueGroupName}} venues even easier while offering a range of exclusive benefits:\n\n- Early access to our most exclusive properties\n- Unlock corporate rates and rewards\n- Private line and corporate experiences\n- Custom menus and prices\n- 24/7 access and support\n- Centralized place for communication and receipts\n\nBest regards,\n{{inviterFirstName}}"
  },
  "onboarding": {
    "eventProgram": {
      "title": "Upload Event Program Details",
      "label": "Event Programs"
    },
    "analyzing": "Analyzing contents..."
  },
  "overview": {
    "annualizedSpend": "Annualized Spend",
    "annualizedSpendTooltip": "<0>Annualized Spend</0> projects annualized processed spend for the selected venue(s), calculated from payments since the first transaction of the current year."
  },
  "helpCenter": "in the Ande Help Center.",
  "shell": {
    "footer": {
      "smsProgram": "SMS Program"
    }
  },
  "rewards": {
    "seeProgramDetails": "See Program Details"
  },
  "auth": {
    "affiliateProgramSuccess": "You have successfully gained access to the affiliate program. We're taking you to our inventory!"
  },
  "fees": {
    "salesTaxPlaceholder": "e.g. CA Sales Tax"
  },
  "analytics": {
    "paymentMethodsHelp": "Corporate events that were paid outside of Ande (e.g. wire, check, or direct card charge). Using an Ande paylink would have lowered the processing cost."
  },
  "agent": {
    "websiteInquiriesDescription": "Your AI agent handles website inquiries using your venue's knowledge and preferences."
  },
  "agentDashboard": {
    "inquiryInsights": "Inquiry Insights",
    "timing": {
      "heatmapTitle": "When guests inquire — day of week & time of day",
      "heatmapTooltip": "Volume of inbound inquiries by day of week and hour of day, in venue-local time. Use it to spot when staffing or auto-response coverage matters most — especially the share that lands outside business hours, when no human could reply.",
      "noInquiries": "No inquiries in {{scope}}{{suffix}} yet.",
      "outsideHours": "{{pct}}% of inquiries arrive outside business hours",
      "weekendShare": "Weekend inquiries account for {{pct}}% of total volume.",
      "leadTimeNote": "Days between inquiry and requested event date · median with 25th–75th range",
      "leadTimeTooltip": "How far in advance guests inquire, broken down by party size. The bar shows the middle 50% of inquiries (25th–75th percentile); the line is the median. Bigger parties typically plan further out — knowing this helps you set hold times and follow-up cadence.",
      "noLeadTimeInquiries": "No inquiries with an event date and party size in this period yet."
    },
    "guestInsights": {
      "eventTypesTooltip": "Split of inquiries into corporate, social, and other event categories, with each event type ranked by lead volume within its category. Useful for tuning menus, packages, and marketing toward your strongest demand.",
      "noPartySizeInquiries": "No inquiries with a party size yet",
      "partySizeNote": "Guest count requested on {{inquiryCount}} inquiries · most common {{verb}} {{topBuckets}} guests ({{topPct}}%)",
      "noPartySizeInquiriesPeriod": "No inquiries with a party size in this period yet."
    },
    "analytics": {
      "leadsSubmittedMeta": "Inquiries submitted through the agent",
      "leadsSubmittedTooltip": "Total inbound inquiries submitted through the agent.",
      "avgExchangesTooltip": "Average back-and-forth messages per engaged conversation. Longer exchanges usually mean the guest is genuinely planning a booking; very short ones may signal the inquiry was answered and closed quickly.",
      "noInquiriesPeriod": "No inquiries in this period yet.",
      "noVenueInquiriesPeriod": "No venue inquiries in this period yet."
    }
  }
}
